import React, { useState, useEffect } from 'react';
import { useCrud } from '../hooks/useCrud';  // Usando o hook useCrud para CRUD
import StorageManager from '../context/StorageManager';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import SelecionarCategoriaProduto from '../components/Utils/SelecionarCategoriaProduto';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { useProvider, Toast } from '../context/MenuProvider';

const MarcaList = () => {
    const navigate = useNavigate();
    const [query, setQuery] = useState(''); // Termo de pesquisa
    const [marcas, setMarcas] = useState([]); // Marcas carregados
    const [nextUrl, setNextUrl] = useState(null); // URL da próxima página

    const {
      crud,
      setLinks, setBtns
    }=useProvider();
    const { get, loading } = crud || {};  // Obtendo os métodos do hook useCrud
    
    // Função para buscar marcas na API
    const buscarMarcas = async (novaBusca = false) => {
        let url = `/gvendas/marcas/?ordering=nome_da_marca`;

        if (query) url += `&search=${query}`;
        
        
        if (novaBusca) {
            setMarcas([]); // Limpa os marcas anteriores
            setNextUrl(null); // Reseta o nextUrl
        } else if (nextUrl) {
            url = nextUrl; // Se não for nova busca, utiliza o nextUrl
        } else {
          url = null;
        }

        if (!url) return; // Evita chamada se já estiver loading ou sem URL válida
        try{
          const response = await get(url,'pagina');
          if(response){
            const novosMarcas = response[0].results; // Corrigir para acessar o resultado correto
            setMarcas((marcasAnteriores) => novaBusca ? novosMarcas : [...marcasAnteriores, ...novosMarcas]);
            setNextUrl(response[0].next);
          }
          
        }catch(err){
          // Toast.fire({
          //     icon: "error",
          //     title: "Falha ao buscar marcas"
          // });
        }finally{
          
        }
    };

    // Carrega os marcas ao montar o componente ou aplicar um novo filtro
    useEffect(() => {
      buscarMarcas(true); // Sempre faz uma nova busca
    }, [query]);
    
    
    useEffect(() => {
      setLinks([
       // { name: 'Configurar estoque (Casal)', to: '/estoque/sincronizar' },
       // { name: 'Sincronizar marcas', to: '/estoque/sincronizar' },
      ]);
      setBtns([]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns]);
    
    
    
    // Detecta o fim da página para carregar mais marcas
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarMarcas();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    
    return (
        <>
            <BotaoFlutuante to="/marcas/novo" icon="bi-plus"></BotaoFlutuante>
            <div className="">
                <Form>
                    <Form.Group controlId="formBasicSearch">
                      <div className="input-group">
                        <Form.Control 
                            type="text" 
                            placeholder="Digite o nome da marca/fornecedor" 
                            value={query} 
                            onChange={(e) => setQuery(e.target.value)} 
                        />
                        <Button variant="secondary" onClick={() => buscarMarcas(true)}>
                            <i className="bi bi-search"></i>
                        </Button>
                      </div>
                    </Form.Group>
                </Form>
                <div className="list-group mt-3">
                    {marcas.length > 0 ? (
                      marcas.map((x) => (
                        <RenderizarProduto
                          key={x.id}
                          to={`/marcas/${x.id}`}
                          src={x.logomarca}
                          titulo={x.nome_da_marca}
                          text2={`${x.porcentagem_desconto_na_compra}% de desconto na compra e ${x.porcentagem_lucro_na_revenda}% de lucro na revenda`}
                        />
                      ))
                    ) : (
                      !loading && <p className="text-center text-muted">Nenhuma marca encontrada.</p>
                    )}
                    {loading && <p className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !loading && (
                        <Button variant="secondary" onClick={() => buscarMarcas(false)} className="mt-2  text-center">
                            Buscar mais...
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
};

export default MarcaList;